import React, {createRef, useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {useQueryClient} from "react-query";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";

import "../../App.css";
import SystemContext from "../../SystemContext";
import {getDefaultValuesWithoutAlert} from "../../functions/TemplateHelperFunctions";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import Dialog from "../../controls/Dialog";
import BookingQueueStyles from "./styles/BookingQueueStyles";
import BookingForm from "./components/BookingForm";

import useCurrencies from "../../services/currencies/useCurrencies";
import useExchangeRates from "../../services/currencies/useExchangeRatesWithName";
import {Loading} from "../../controls";
import {useSettings} from "../../services/settings";
import {useCompaniesExternal} from "../../services/companies";
import {getCurrencyName, getRates} from "./BookingHelperFunctions";
import __ from "lodash";


const AccessControl = require ("../../AccessControl");


function CustomerNewSpotRequest(props) {
  const SystemData = useContext(SystemContext);
  const classes = makeStyles(BookingQueueStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Manage BOOKINGS", "Client ADMIN", "Client ACCESS"]);
  const userInfo = AccessControl.getUserInfo();
  const userClass = userInfo?.userClass;

  const queryClient = useQueryClient();
  const extraKeys = ["SYSTEM", moment().format("YYYY-MM-DD")];
  const currencies = useCurrencies({queryClient, extraKeys: []});
  const exchangeRates = useExchangeRates({queryClient, extraKeys});
  const terms = useSettings({queryClient, extraKeys: ["TERMS"]});
  const companyData = useCompaniesExternal({queryClient, extraKeys: [userInfo.companyUuid]});
  const [defaults, setDefaults] = useState(null);

  if(terms && terms.data)
    console.log(terms.data);

  const history = useHistory();
  const handleClose = event => {
    SystemData.goHome(history);
  };

  const record = {
    awbPrefix: "",
    awbSerial: "",
    stackable: "NONE",
    tiltable: "NONE",
    crated: "NONE",
    dgr: "NONE",
    avi: "NONE",
    outSized: "NONE",
    commodity: "",
    specialLoad: "",
    delivery: "",
    charterOrigin: "",
    destination: "",
    dimensions: [],
    rates: [],
    documents: [
      {id: "7dede05f-f482-453f-86ae-18eebffdef5a", documentType: "AWB", description: ""},
      {id: "ab2ec983-d066-49b3-8ce1-dc8139f70388", documentType: "PACK", description: ""},
      {id: "e50c1d8c-1918-4cd5-a900-cefe7a003499", documentType: "INVOICE", description: "" },
      {id: "49397d22-5ef0-49fd-aeaa-8a19aeb17fbd", documentType: "DGSD", description: ""},
      {id: "80d6ae41-6682-41ea-927b-7e6bcaa9635e", documentType: "IMAGE", description: ""},
    ],
  }

  const getDefaults = async () => {
    const defaults = await getDefaultValuesWithoutAlert(SystemData, "booking", "defaults");
    if (!defaults)
      return null;
    return defaults;
  }

  getDefaults()
    .then((bookingDefaults) => {
      if (!defaults)
        setDefaults(bookingDefaults);
    })
    .catch((error) => {
      handleClose();
      SystemData.alert("Error", error);
    });

  if (userClass ==="GSA" &&
    companyData && companyData.data && exchangeRates && exchangeRates.data && Array.isArray(exchangeRates.data)) {
    const company = companyData.data;
    record["gsaCompanyUuid"] = userInfo.companyUuid;
    record["gsaCompanyName"] = company.companyName;
    record["gsaCurrencyRates"] = getRates(company.defaultCurrencyCode, exchangeRates.data);
    record["gsaDefaultCurrencyCode"] = company.defaultCurrencyCode;
    record["gsaDefaultCurrencyName"] = getCurrencyName(company.defaultCurrencyCode, currencies.data);

    if (userInfo && __.has(userInfo, ["firstName"]) && __.has(userInfo, ["lastName"])) {
      record["gsaContactSalutation"] = userInfo.title;
      record["gsaContactFirstName"] = userInfo.firstName;
      record["gsaContactLastName"] = userInfo.lastName;
      record["gsaContactEmail"] = userInfo.email;
      record["gsaCompanyContact"] = `${userInfo.title ? userInfo.title + " " : ""} ${userInfo.firstName ?? ""} ${userInfo.lastName ?? ""} ${userInfo.email?`(${userInfo.email})`:``}`;
    }
  }

  return (isAuthenticated &&
    <div
      className="CustomerNewSpotRequest"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="customernewspotrequest"
        pageName="New Spot Request"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 40, marginRight: 40, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, backgroundColor: "#f1f1f1"}}
      >
        {/* formMode:*/}
        {/* =========*/}
        {/* GSA - for GSA bookings (does not require GSA selection),*/}
        {/* OPERATOR - for system operator bookings (requires GSA selection),*/}
        {/* SLR - for special load requests.*/}
        {/* userClass will return "OPERATOR" for Magma users and companyUuid for external users*/}

        <div style={{display: "flex"}}>
          {exchangeRates.data
            ?
              <BookingForm
                defaults={defaults}
                record={record}
                canEdit={canEdit}
                newBooking={true}
                spotBooking={true}
                formMode={userClass||"OPERATOR"} // GSA - for GSA bookings (does not require GSA selection), OPERATOR - for system operator bookings (requires GSA selection), SLR - for special load requests
                close={handleClose}
                classes={classes}
                exchangeRates={exchangeRates.data}
                currencies={currencies.data}
                terms={terms.data}
                dialogStates={{showDialog: true, gsaCompanyUuid: userClass !== "GSA" ? "" : record.gsaCompanyUuid, gsaCompanyName: record.gsaCompanyName}}
                showFullPage={false}
                fullPageStyle={{backgroundColor: "#e1e1e1"}}
              />
            :
              <Dialog
                //title="Loading Exchange Rates"
                message="Loading Exchange Rates"
                open={true}
                buttons={{}}
              >
                <Loading/>
              </Dialog>
          }

        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default CustomerNewSpotRequest;
